import { connect } from 'react-redux'

import component from 'components/Users'

const mapActionCreators = {}

const mapStateToProps = (state) => ({
  users: state.users
})

export default connect(mapStateToProps, mapActionCreators)(component)



// WEBPACK FOOTER //
// ./src/routes/Users/containers/UsersContainer.js